import React, { Fragment } from 'react'

import { Typography, Grid, Button } from '@mui/material'

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { Loading } from '../../UI'

interface SelectPickingRouteModalProps {
  pickingRouteIds: number[]
  validateRoutesRelated: (pickingRouteId: number) => void
  loading?: boolean
}

export const SelectPickingRouteModal: React.FC<
  SelectPickingRouteModalProps
> = ({ pickingRouteIds, validateRoutesRelated, loading }) => {
  return (
    <Fragment>
      <Typography variant='body2' align='center'>
        Existen mas de una ruta de picking con el mismo tote. Seleccione la que
        desea validar
      </Typography>
      <Grid
        container
        direction='row'
        spacing={1}
        justifyContent='center'
        alignItems='center'
        style={{ marginTop: '5px' }}
      >
        {pickingRouteIds.map((pickingRoute) => (
          <Grid
            item
            xs={6}
            key={pickingRoute}
            container
            spacing={1}
            direction='column'
            alignItems='center'
            justifyContent='center'
          >
            <Button
              disabled={loading}
              variant='contained'
              color='primary'
              endIcon={loading ? <Loading /> : <ArrowForwardIosIcon />}
              onClick={() => {
                validateRoutesRelated(pickingRoute)
              }}
              style={{ width: '400px', marginLeft: 10, marginTop: 15 }}
            >
              {pickingRoute}
            </Button>
          </Grid>
        ))}
      </Grid>
    </Fragment>
  )
}
